import { createNamespacedHelpers } from 'vuex'
const { mapState: activityMapState } = createNamespacedHelpers('activity')

export default {
  computed: {
    ...activityMapState([
      'activity'
    ]),
  },

  methods: {
    async confirm(message, title, {
      confirmButtonText = '确定',
      cancelButtonText = '取消',
      showCancelButton = true
    }) {
      await this.$msgbox({
        title,
        customClass: 'message-box-width',
        message: message,
        showCancelButton,
        confirmButtonText,
        cancelButtonText,
      })
    },
  }
}
